// extracted by mini-css-extract-plugin
export default {"container":"Reports_container__Jt0M4","reports":"Reports_reports__IOzxy","reportsHeader":"Reports_reportsHeader__WhqZS","reportsContainer":"Reports_reportsContainer__Wv58-"};